import React, { Component } from 'react';
import { Big3Common } from '../../../js/IncludeManager'
import {  NoResult, GoodsPhoto } from "../../../js/ComponentManager";
/* 개발담당:양유빈
 * 화면기능:주문목록, 포장완료 목록
 * 세부설명:
*/

export class OrderList extends Component {
    static displayName = OrderList.name;

    constructor(props) {
        super(props);

        this.Ord_Status = "JM";
        if (this.props.ContentState !== undefined && this.props.ContentState !== null) {
            if (this.props.ContentState.Ord_Status !== undefined) {
                this.Ord_Status = this.props.ContentState.Ord_Status;
            }
            if (this.props.ContentState.FromDate !== undefined) {
                this.fromDate = this.props.ContentState.FromDate;
            }
            if (this.props.ContentState.ToDate !== undefined) {
                this.toDate = this.props.ContentState.ToDate;
            }
        }

        this.state = {
            OrdMgtMstList: [],
            MgtMstCount: []
        };   
        
        this.handleCalendarChange = this.handleCalendarChange.bind(this);
        this.handleSearch_Click = this.handleSearch_Click.bind(this);
        this.handleDtl_Click = this.handleDtl_Click.bind(this);
        this.handleRtiDtlApp_Click = this.handleRtiDtlApp_Click.bind(this);
        this.handleTab_Click = this.handleTab_Click.bind(this);
    }
    //초기화
    async componentDidMount() {
        await this.CallOrdMgtMstListData();
    }
    //주문목록 조회
    async CallOrdMgtMstListData() {
        try {

            Big3Common.Util.LoadingOn();            
            let Data = await Big3Common.Post('api/Order/OrderMgr/GetOrdMgtMstList',
                {
                    "Ord_Status": this.Ord_Status
                }, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.multiDataTable);
                const OrdMgtMstList = DataList.MgtMstList;
                const MgtMstCount = DataList.MgtMstCount;
                this.setState({ OrdMgtMstList: OrdMgtMstList, MgtMstCount: MgtMstCount });
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallRtiListData: ", e)
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
        return false;
    }
    //달력일정 변경
    handleCalendarChange(retunValue) {
        let TagId = retunValue.returnId;
        this.setState({ [TagId]: retunValue.SelectDate });
    }
    //검색버튼
    handleSearch_Click(event) {
        this.CallOrdMgtMstListData();
        event.preventDefault();
    }
    //상세보기
    handleDtl_Click(event, list) {
        let ContentState = {
            Union_Uid: list.union_uid,
            Ordgrp_No: list.ordgrp_no,
            Ord_Status: this.Ord_Status
        }
        this.props.RenderComponent('OrderDtl', ContentState);
        event.preventDefault();
    }
    //소매매장 보기
    handleRtiDtlApp_Click(event,list) {
        let ContentState = {
            Union_Uid: list.union_uid,
            Ordgrp_No: list.ordgrp_no,
            Ord_Status: this.Ord_Status
        }
        this.props.RenderComponent('RtiDtlAp', ContentState);
        event.preventDefault();
    }
    //Tab 링크
    async handleTab_Click(event, Ord_Status) {
        if (Ord_Status === "GR" || Ord_Status==="CS") {
            //거래완료
            let ContentState = {
                Ord_Status: Ord_Status
            }
            this.props.RenderComponent('CompletedList', ContentState);
        }
        else {
            this.Ord_Status = Ord_Status;
            await this.CallOrdMgtMstListData();
        }
        event.preventDefault();
    }
    //탭
    Tabrender() {        
        return (
            <div className="tab_box_v2">
                <div className="f_tap" onClick={(e) => { this.handleTab_Click(e, 'JM') }}><div className={this.Ord_Status === "JM" ? "s_tap tap_select" : "s_tap"}>주문목록<span></span></div></div>
                <div className="f_tap" onClick={(e) => { this.handleTab_Click(e, 'PJ') }}><div className={this.Ord_Status === "PJ" ? "s_tap tap_select" : "s_tap"}>포장완료<span></span></div></div>
                <div className="f_tap" onClick={(e) => { this.handleTab_Click(e, 'GR')}}><div className="s_tap">거래완료</div></div>
                <div className="f_tap" onClick={(e) => { this.handleTab_Click(e, 'CS') }}><div className="s_tap">취소목록</div></div>
            </div>
        )
    }
    OrdMgtMstrender(DataList) {
        return (
            DataList.map(list =>
                <div className="alert_content" key={`${list.uid}${list.union_uid}${list.ordgrp_no}`}>
                    <div className="alert_img" onClick={(e) => { this.handleRtiDtlApp_Click(e, list) }}>
                        <GoodsPhoto
                            className="alert_img_in"
                            ImageSrc={list.img_220}
                        />
                    </div>
                    <div className="alert_txt" onClick={(e) => { this.handleDtl_Click(e,list) } }>
                        <div className="alert_title">{list.retail_area_nm === "" ? "" : `[${list.retail_area_nm}]`} {list.retail_org_name}</div>
                        <div className="product_name">주문 품목:  {list.goods_nms }</div>
                        <div className="product_name">주문 금액: {Big3Common.Util.Money(list.goods_price)}원</div>
                        <div className="product_name"> 결제: {list.pay_idx_nm}</div>
                        {list.ord_idx === "EX" ? <div className="excel_btn">엑셀주문장</div> : ""}
                    </div>
                </div>
            )
        )
    }    
    render() {
        const Tabrender = this.Tabrender();         
        const OrgMgt = this.state.OrdMgtMstList;
        const OrdDtList = Big3Common.Util.groupBy(OrgMgt, list => list.ord_dt);
        const OrdDtListJson = [];
        for (const item of OrdDtList.entries()) {
            OrdDtListJson.push({
                "Ord_Dt": item[0],
                "DataList": item[1],
            });
        }
      
        this.TitleCount = () => {
            const JMCount = this.state.MgtMstCount.map(list => list.jmcount)[0] || 0;        
            if (this.Ord_Status === "JM") {
                return (
                    <div className="order_number">미처리 된 주문은 <span>{JMCount}건</span> 입니다.</div>
                )
            }
            else if (this.Ord_Status === "PJ") {
                const PJCount = this.state.MgtMstCount.map(list => list.pjcount)[0] || 0;        
                return (
                    <div className="order_number">포장완료는 <span>{PJCount}건</span> 입니다.</div>
                )
            }
            else {
                return "";
            }
        }
        return (
            <div>
                {Tabrender }
                <div className="container_box2 m_f_margin u_padding">
                    <div className="d_info_txt">
                        상품은 <span>클로디 삼촌</span>이 픽업합니다. <br></br>
                        <span>사입과 동일하게</span> 포장하시면 됩니다.
                    </div>
                    {this.TitleCount()}
                    {
                        OrdDtListJson.map(list =>
                            <div key={list.Ord_Dt}>
                                <div className="date">{list.Ord_Dt}</div>
                                {this.OrdMgtMstrender(list.DataList)}
                            </div>
                        )
                    }
                </div>
                <div className="float_excel_btn" onClick={() => { this.props.RenderComponent('OrderDtlExcel') }}></div>       
                <NoResult
                    Visible={this.state.OrdMgtMstList.length === 0 ? true : false}
                    Top={"60%"}
                />
            </div>
        );
    }
}
